module.exports = __webpack_public_path__ + "img/go.00782f78.png";